module.exports = __webpack_public_path__ + "img/pagination3-icon.90e1494c.png";